<template>
  <div class="home-container">
    <div class="text-container">
      <h1>
        Comprehensive benchmarking tool for listed companies and Executives.
      </h1>
      <h5>
        Uncover insights on Board, Management and ESG performance.
      </h5>
    </div>
    <div class="accounts-container">
      <div class="accounts-options">
        <div class="account-option">
          <div class="account-info">
            <h4>You are a Corporate or Advisor</h4>
            <p>
              Access investors' perspectives on aspects such as your board of directors, 
              management, remuneration and extra-financial communication.
            <br><br>
              Gain unparalleled insights with an extensive collection of ESG 
              metrics covering taxonomy, risk factors, climate strategies, human capital, and 
              ethical considerations.
            <br><br>
              Assess your company's performance across hundreds of criteria compared to any 
              benchmark—an index, sector, custom portfolio of companies, or direct 
              competitor. 
            </p>
            <ul>
              <li>Monitor and benchmark ESG objectives</li>
              <li>Identify best practices for financial and legal AGM/EGM resolutions</li>
              <li>Assess performance conditions of your executive packages</li>
              <li>Evaluate the performance of your auditors</li>
            </ul>
            <div class="button-container">
              <div
                class="account-button demo-button"
                @click="showCorporateModal = !showCorporateModal"
              >{{ _tr("global.demo", "Demo") }}</div>
              <a
                class="account-button cta-button"
                href="https://meetings.hubspot.com/guillaume-moinet/meet-our-sales-team"
              >{{ _tr("global.meet_sales_team", "Contactez-nous") }}</a>
            </div>
          </div>
        </div>
        <div class="account-option">
          <div class="account-info">
            <h4>You are an Executive or Board Member</h4>
            <p>
              Embark on a journey of individual empowerment with our advanced 
              remuneration analytics suite designed specifically for managers and board 
              members. 
            <br><br>
              Effortlessly access valuable insights into your individual compensation, benchmark
              against industry peers, and navigate the complexity of remuneration negotiations
              with confidence.
            <br><br>
              Maximize your potential with our continuously updated dataset of 15,000 profiles.
            </p>
            <ul>
              <li>Assess your remuneration with real and policy packages</li>
              <li>Key metrics: say-on-pay, KPIs, shareholders meeting scores</li>
              <li>c. 350 benchmark criteria including 31 focused on extra-financial and climate topics</li>
            </ul>
            <div class="button-container">
              <div
                class="account-button demo-button"
                @click="showExecutiveModal = !showExecutiveModal"
              >{{ _tr("global.demo", "Demo") }}</div>
              <Subscribe class="account-button cta-button subscribe-menu"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal :show="showCorporateModal" :size="modalSize" mitt="close-modal-corporate-demo">
      <template v-slot:header>{{
        _tr("global.corporate", "Entreprise")
      }}</template>
      <template v-slot:default>
        <ul class="nav nav-pills nav-justified">
          <li class="nav-item" >
            <a class="nav-link active single-tab" href="#">
              Climate dissenting vs non dissenting
            </a>
          </li>
          <li class="nav-item hidden" ></li>
        </ul>
        <div class="video-container">
          <div style="padding:56.25% 0 0 0;position:relative;">
            <iframe 
              src="https://player.vimeo.com/video/915885801?player_id=0&amp;app_id=584799&amp;title=0" 
              frameborder="0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              color="#757575"
              style="
                position:absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;" 
              title="Climate dissenting vs non dissenting">
            </iframe>
          </div>
        </div>
      </template>
    </Modal>
    <Modal :show="showExecutiveModal" :size="modalSize" mitt="close-modal-executive-demo">
      <template v-slot:header>{{
        _tr("global.executive", "Exécutif")
      }}</template>
      <template v-slot:default>
        <ul class="nav nav-pills nav-justified">
          <li class="nav-item"  @click="showExecutiveVideo = 'Video1'">
            <a class="nav-link" :class="{ 'active': showExecutiveVideo === 'Video1' }" href="#">
              Director - Non exec compensation
            </a>
          </li>
          <li class="nav-item" @click="showExecutiveVideo = 'Video2'">
            <a class="nav-link" :class="{ 'active': showExecutiveVideo === 'Video2' }" href="#">
              Real & Policy
            </a>
          </li>
        </ul>
        <div class="video-container">
          <div style="padding:56.25% 0 0 0;position:relative;" v-if="showExecutiveVideo == 'Video1'">
            <iframe 
              src="https://player.vimeo.com/video/915885437?player_id=0&amp;app_id=58479&amp;title=0" 
              frameborder="0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              style="
                position:absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;" 
              title="Director - Non exec compensation">
            </iframe>
          </div>
          <div style="padding:56.25% 0 0 0;position:relative;" v-if="showExecutiveVideo == 'Video2'">
            <iframe 
              src="https://player.vimeo.com/video/915885944?player_id=0&amp;app_id=58479&amp;title=0" 
              frameborder="0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              style="
                position:absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;" 
              title="Real & Policy">
            </iframe>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Subscribe from "@/components/menu/Subscribe.vue";
import Modal from "@/tools/Modal.vue";
export default {
  components: {
    Subscribe,
    Modal,
  },
  data() {
    return {
      showCorporateModal: false,
      showExecutiveModal: false,
      showExecutiveVideo: "Video1",
      modalSize: 'modal-large',
    };
  },
  mounted() {
    this.emitter.on("close-modal-corporate-demo", () => {
      this.showCorporateModal = false;
    });
    this.emitter.on("close-modal-executive-demo", () => {
      this.showExecutiveModal = false;
    });
    if (this.isAuthenticated) {
      this.$router.push('/mandate/bench-mandatary/');
    }
  },
  unmounted() {
    this.emitter.all.delete("close-corporate-demo");
    this.emitter.all.delete("close-executive-demo");
  },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";

.text-container {
  font-family: "Lato";
  text-align: center;
  margin: 30px auto 35px;
  padding: 0 35px;
  @media screen and (max-width: 665px) {
    margin-top: 35px;
  }
}

.text-container > h1 {
  color: #1ABC9C;
  font-size: 30px;
}

.text-container > h5 {
  color: $primary;
  font-size: 22px;
  padding-top: 5px;
}

.accounts-container {
  margin: 0 55px;
  font-size: 15px;
  
  @media screen and (max-width: 1182px) {
    margin: 0 80px;
  }
  @media screen and (max-width: 700px) {
    margin: 0 50px;
  }
  
  @media screen and (max-width: 626px) {
    margin: 0 30px;
  }
  
  @media screen and (max-width: 488px) {
    margin: 0 20px;
  }
}

.accounts-options {
  display: flex;
  gap: 30px;
  margin-bottom: 50px;
  
  @media screen and (max-width: 1176px) {
    flex-direction: column;
    gap: 25px;
  }
}

.account-option {
  background-color: $white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 30px 35px 0;
  width: 50%;
  
  @media screen and (max-width: 1176px) {
    width: 100%;
  }
}

.account-info {
  color: $primary;
}

.account-info > p {
  color: $text-grey;
  text-align: justify;
  padding: 10px 15px 10px 5px;
  min-height: 205px;
  
  @media screen and (max-width: 1495px) {
    min-height: 225px;
  }
  @media screen and (max-width: 1463px) {
    min-height: 245px;
  }
  @media screen and (max-width: 1344px) {
    min-height: 275px;
  }
    
  @media screen and (max-width: 1176px) {
    min-height: 90px;
  }
}

.account-info > ul {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  padding: 20px 10px; 
  min-height: 215px;
  @media screen and (max-width: 1486px) {
    min-height: 260px;
  }
  @media screen and (max-width: 1477px) {
    min-height: 220px;
  }
  @media screen and (max-width: 1423px) {
    min-height: 257px;
  }
  @media screen and (max-width: 1303px) {
    min-height: 300px;
  }
  
  @media screen and (max-width: 1176px) {
    min-height: 0;
  }
  
   > li {
    color: $text-grey;
    font-size: 16px;
    font-weight: 700;
    line-height: 43px;
    margin: 0 5%;
    @media screen and (max-width: 1477px) {
      font-size: 15px;
    }
    
    @media screen and (max-width: 1176px) {
      font-size: 16px;
    }
    
    @media screen and (max-width: 588px) {
      font-size: 15px;
    }
    @media screen and (max-width: 565px) {
      font-size: 14px;
      line-height: 38px;
    }
  }
}

.button-container {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin: 30px 0;
}

.account-button {
  color: $text-grey;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  padding: 11px;
  border-radius: 10px;
  text-transform: uppercase;
  text-decoration: none;
  border: 1px solid #e0e3eb;
  bottom: 35px;
}

.cta-button {
  background-color: $cta-button;
  width: 150px; 

  &:hover {
    color: $text-grey;
  }
}

.subscribe-menu {
  cursor: pointer;
  height: 42px;
  z-index: 5;
}

.demo-button {
  background-color: $light-blue;
  width: 100px; 
  cursor: pointer;
}

.nav-justified {
  align-items: center;
}

.nav > .nav-item {
  font-size: 16px;
  flex-basis: auto;

  > .single-tab {
    cursor: default !important;
  }
}

.video-container {
  margin: 30px auto;
  width: 90%;
  
  @media screen and (max-width: 1182px) {
    margin: 30px auto 0;
    width: 95%;
  }
}
</style>
